import React, { useEffect, useState } from 'react';
import { simboloMoneda } from '../services/negocioActual';
import { obtenerInstruccionesPago } from '../services/pedidosService';
import { METODOS_PAGO } from '../utils/tiendaPago';
import { instruccionesPorDefecto, mensajeConfirmacion } from '../utils/pedidoEtapas';
import CampoNumero from './CampoNumero';

// ✅ Confirmar pedido: la dueña revisa envío y forma de pago, escribe (o usa la
// guardada) cómo pagar, y se le manda a la clienta por WhatsApp con el enlace
// para seguir su pedido. El pedido queda "Confirmado" (sql/121).
export default function ConfirmarPedidoModal({ pedido, enlace, guardando, onConfirmar, onCerrar }) {
  const [envio, setEnvio] = useState(pedido.envio === null || pedido.envio === undefined ? '' : String(pedido.envio));
  const [pago, setPago] = useState(pedido.pago || '');
  const [guardadas, setGuardadas] = useState({});
  const [instrucciones, setInstrucciones] = useState('');
  const [editada, setEditada] = useState(false);
  const [recordar, setRecordar] = useState(true);

  useEffect(() => {
    obtenerInstruccionesPago().then(setGuardadas).catch(() => setGuardadas({}));
  }, []);
  // Al cambiar la forma de pago, se carga su texto guardado (si no la editaron a mano).
  useEffect(() => {
    if (!editada) setInstrucciones(guardadas[pago] || instruccionesPorDefecto(pago));
  }, [pago, guardadas, editada]);

  const domicilio = pedido.entrega !== 'tienda';
  const mensaje = mensajeConfirmacion(pedido, {
    envio: domicilio ? (envio === '' ? null : envio) : null, pago, instrucciones, enlace, simbolo: simboloMoneda(),
  });
  const necesitaDatos = pago && !['efectivo', 'tarjeta'].includes(pago) && !instrucciones.trim();

  return (
    <div onClick={onCerrar} style={{ position: 'fixed', inset: 0, background: 'rgba(20,10,30,.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Confirmar pedido"
        style={{ background: '#fff', borderRadius: '18px', width: '100%', maxWidth: '480px', maxHeight: '92vh', overflowY: 'auto', padding: '20px', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
          <b style={{ fontSize: '17px' }}>✅ Confirmar pedido</b>
          <button onClick={onCerrar} aria-label="Cerrar" style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer' }}>✕</button>
        </div>
        <p style={{ margin: '0 0 14px', fontSize: '13px', color: '#6B7280' }}>
          Le mandas a {pedido.cliente_nombre} el total y cómo pagar. En su enlace verá "Confirmado".
        </p>

        {domicilio && (
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 700, marginBottom: '4px' }}>🚚 Costo del envío</label>
            <CampoNumero valor={envio} onChange={setEnvio} prefijo={simboloMoneda()} min={0} placeholder="0 = gratis"
              ayuda={pedido.direccion ? `Dirección: ${pedido.direccion}` : 'Déjalo vacío si aún no lo sabes'} />
          </div>
        )}

        <div style={{ marginBottom: '12px' }}>
          <label htmlFor="conf-pago" style={{ display: 'block', fontSize: '13px', fontWeight: 700, marginBottom: '4px' }}>💳 Forma de pago</label>
          <select id="conf-pago" value={pago} onChange={(e) => { setPago(e.target.value); setEditada(false); }}
            style={{ width: '100%', padding: '10px', borderRadius: '10px', border: '1px solid #D1D5DB', fontSize: '14px', backgroundColor: 'white' }}>
            <option value="">Sin definir</option>
            {METODOS_PAGO.map((m) => <option key={m.valor} value={m.valor}>{m.icono} {m.nombre}</option>)}
          </select>
        </div>

        <div style={{ marginBottom: '6px' }}>
          <label htmlFor="conf-instr" style={{ display: 'block', fontSize: '13px', fontWeight: 700, marginBottom: '4px' }}>📝 Cómo pagar</label>
          <textarea id="conf-instr" value={instrucciones} rows={3}
            onChange={(e) => { setInstrucciones(e.target.value.slice(0, 600)); setEditada(true); }}
            placeholder={pago === 'transferencia' ? 'Ej: BAC 7xx-xxx-xxx a nombre de Lolita’s Store' : 'Datos para pagar (cuenta, link…)'}
            style={{ width: '100%', boxSizing: 'border-box', padding: '10px', borderRadius: '10px', border: `1px solid ${necesitaDatos ? '#F59E0B' : '#D1D5DB'}`, fontSize: '13px', fontFamily: 'inherit' }} />
          {pago && (
            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>
              <input type="checkbox" checked={recordar} onChange={(e) => setRecordar(e.target.checked)} />
              Guardar este texto para los próximos pedidos con esta forma de pago
            </label>
          )}
          {necesitaDatos && <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#B45309' }}>Escribe a dónde te paga (cuenta, link…).</p>}
        </div>

        <p style={{ margin: '12px 0 6px', fontSize: '13px', fontWeight: 700 }}>Así le llega:</p>
        <pre style={{ margin: '0 0 14px', whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontSize: '13px', background: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: '12px', padding: '10px', color: '#14532D', maxHeight: '220px', overflowY: 'auto' }}>{mensaje}</pre>

        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <button onClick={onCerrar} disabled={guardando} className="k-btn-soft">Cancelar</button>
          <button onClick={() => onConfirmar({ envio: domicilio ? envio : undefined, pago, instrucciones, recordar, mensaje })}
            disabled={guardando || !pedido.cliente_telefono}
            title={pedido.cliente_telefono ? '' : 'El pedido no tiene teléfono'}
            style={{ padding: '10px 16px', borderRadius: '10px', border: 'none', fontWeight: 700, fontSize: '14px', fontFamily: 'inherit',
              backgroundColor: '#25D366', color: 'white', cursor: 'pointer', opacity: pedido.cliente_telefono ? 1 : 0.5 }}>
            {guardando ? 'Guardando…' : '💬 Confirmar y enviar por WhatsApp'}
          </button>
        </div>
      </div>
    </div>
  );
}
